import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';

export const userService = {
  profile: () => axios.get(Pathes.User.profile),
  veriffStatus: () => axios.get(Pathes.User.veriffStatus),
  canDeleteAccount: () => axios.get(Pathes.User.canDeleteAccount),
  deleteAccount: () => axios.delete(Pathes.User.deleteAccount),
  updateProfileContacts: payload =>
    axios.post(Pathes.User.doUpdateContactInfo, payload),
  updatePhone: payload => axios.post(Pathes.User.doUpdatePhone, payload),
  requestChangeEmail: payload =>
    axios.post(Pathes.User.requestChangeEmail, payload),
  resendChangeEmailCode: () => axios.post(Pathes.User.resendChangeEmailCode),
  verifyChangeEmailCode: payload =>
    axios.post(Pathes.User.verifyChangeEmailCode, payload),
  phoneVerify: () => axios.get(Pathes.User.sentCodes),
  phoneVerifyResendCode: payload => axios.post(Pathes.User.sentCodes, payload),
  phoneVerifySubmitCode: payload =>
    axios.post(Pathes.User.validatePhoneNumber, payload),
};
